companyAdmin: Admin
companyPrincipal: Primary
companyAccountant: Billing
users: Users
managesYachts_one: Manages <strong>{{ count }}</strong> yacht
managesYachts_other: Manages <strong>{{ count }}</strong> yachts
nameManagesYachts_one: '{{ name }} manages 1 yacht'
nameManagesYachts_other: '{{ name }} manages {{ count }} yachts'
managesReservations_one: Manages <strong>{{ count }}</strong> reservation
managesReservations_other: Manages <strong>{{ count }}</strong> reservations 
nameManagesReservations_one: '{{ name }} manages 1 reservation'
nameManagesReservations_other: '{{ name }} manages {{ count }} reservations'
nameManagesProposals_one: '{{ name }} manages 1 charter proposal'
nameManagesProposals_other: '{{ name }} manages {{ count }} charter proposals'
activeSeat: Active Seat
userProfile:
  edit: Edit User
  create: Create a user
  updated: User updated
  chooseMigration: Choose another user to take over management of them.
agentCount_one: '{{ count }} agent'
agentCount_other: '{{ count }} agents'
search: Search Users
noCompany: No company
roles:
  title: Permissions & Roles
  actions:
    grantAdmin:
      label: Grant Administrator role
      notification: '{{ name }} is now an administrator'
    revokeAdmin:
      label: Revoke Administrator role
      notification: '{{ name }} is no longer an administrator'
    grantCentral:
      label: Grant Fleet Editor role
      notification: '{{ name }} is now a Fleet Editor'
    revokeCentral:
      label: Revoke Fleet Editor role
      notification: '{{ name }} is no longer a Fleet Editor'
    appointAccountant: 
      label: Appoint as Billing Contact
      notification: "{{ name }} is now your company's Billing Contact"
    removeAccountant:
      label: Remove Billing Contact
      notification: "{{ name }} is no longer your company's Billing Contact"
    appointPrincipal: 
      label: Appoint as Primary Contact
      dialogTitle: New Primary Contact
      warningTitle: |
        By replacing yourself as your company's Primary Contact, you will loose
        this role, and become an admin.
      warningBody: You will not be able to undo this operation.
      confirm: Appoint <strong>{{ name }}</strong> as your company's Primary Contact.

      notification: "{{ name }} is now your company's Primary Contact"
  details:
    admin: |
      Users with the Administrator role are allowed to manage most of your
      company's information in the Charter Index system, including
      subscriptions, payment methods, offices, and other users.
    central: |
      Users with the Fleet Editor role are allowed to update all of your yachts'
      information in Charter Index.
    accountant: |
      Your company's Billing Contact will receive the invoices Charter Index
      sends you. If you do not appoint a Billing Contact, invoices will be sent
      to your company's Primary Contact.<br/><br/>There can be only one Billing
      Contact in your company.
    principal: |
      Your company's Primary Contact is Charter Index's main point of contact
      with your company. They have all of the permissions of an Administrator.
      <br/><br/>There can be only one Primary Contact in your company.
accountEmails:
  sendWelcomeEmail: 'Send welcome email with login details'
  welcome:
    label: Re-send welcome email
    notification: The welcome email has been re-sent to {{ name }}
  remind:
    label: Send account details reminder
    notification: Account details have been emailed to {{ name }}
    tooltip: |
      Send {{ name }} an email reminding them of where to log in, their
      username, and their temporary password if they have never logged in, or
      how to reset their password if they have forgotten it.
emailDomainWarning: |
  This email address does not match your company's email domain of
  @{{ companyDomain }}. You <strong>can</strong> use this email address, but
  please double check that it is correct.
verifyEmail:
  title: Verify Email Address
  description: |
    We have sent an email to <strong>{{ email }}</strong> containing a verification code. Enter
    that code below to confirm your new email address.
  label: 'Code'
  error:
    title: That code does not appear to be correct.
    description: Double check the email, and try again.
emailPermissionDescription: Only your company's Primary Contact may edit other users' email addresses.
marketingEmailLabel: I want to receive marketing emails from Charter Index
password:
  change: Change Password
  requirements: 
    length:
      label: At least 8 letters long
      validity: Must be at least 8 letters long.
    upperCase:
      label: An upper case letter
      validity: Must contain an upper case letter.
    lowerCase:
      label: A lower case letter
      validity: Must contain a lower case letter.
    number:
      label: A number
      validity: Must contain a number.
    confirm: 
      label: Passwords must match
      validity: Passwords must match.
  show: Show Password
  hide: Hide Password
  changedNotification: Your password has been updated.
  failedToUpdate: Unfortunately we could not update your password.
noContactInfo: No contact information available.
